import {
  ChakraProvider,
  Box,
  extendTheme,
  useColorMode,
  ThemeConfig,
} from "@chakra-ui/react";
import CallToAction from "./components/CallToAction";
import { Helmet } from "react-helmet";
import Navbar from "./components/Navbar";
import og_image from "./assets/og_image.png";
import { ColorModeSwitcher } from "./ColorModeSwitcher";
import { useEffect } from "react";
// import Users from "./components/Users";
import AboutUs from "./components/AboutUs";
import PricingPage from "./components/PricingPage";
import SecurityPage from "./components/SecurityPage";
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import circles from "./assets/circles.svg";
// import Features from "./components/Features";
// import Conclusion from "./components/Conclusion";
import Footer from "./components/Footer";
import pills_bottom from "./assets/pills_bottom.svg";
// import ComparisonPage from "./components/ComparisonPage";
import TestimonialsPage from "./components/TestimonialsPage";
import posthog from 'posthog-js';
// import Features from "./components/Features";
import Users from "./components/Users";
import Features from "./components/Features";
// import BlogIndex from "./components/blog/BlogIndex";
// import BlogPage from "./components/blog/BlogPage";

const config: ThemeConfig = {
  initialColorMode: "dark",
  useSystemColorMode: false,
};

const theme = extendTheme({
  config,
  styles: {
    global: {
      body: {
        overflowX: "hidden"
      }
    }
  }
});

function ForceDarkMode(props: { children: JSX.Element }) {
  const { colorMode, toggleColorMode } = useColorMode();

  useEffect(() => {
    if (colorMode === "dark") return;
    toggleColorMode();
  }, [colorMode, toggleColorMode]);

  return props.children;
}


// @ts-ignore
window.intercomSettings = {
  api_base: "https://api-iam.intercom.io",
  app_id: "ce8fl00z",
  action_color: "#6b46c1",
  background_color: "#342867",
};

const RedirectToExternal = ({ url }: { url: string }) => {
  useEffect(() => {
    window.location.href = url; // 'https://form.typeform.com/to/aRlsi04N';
  }, [url]);

  return null;
};

export const App = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.innerHTML = `(function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/ce8fl00z';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();`;
    document.body.appendChild(script);
  }, []);
  useEffect(() => {
    // Initialize PostHog
    posthog.init('phc_CnzwIB0W548wN4wEGeRuxXqidOlEUH2AcyV2sKTku8n', {
      api_host: 'https://app.posthog.com'
    });
  }, []);

  useEffect(() => {
    // Handle hash-based scrolling (e.g., /#features)
    const hash = window.location.hash;
    if (hash) {
      const elementId = hash.substring(1); // Remove the '#'
      const element = document.getElementById(elementId);
      if (element) {
        // Small delay to ensure the page has rendered
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, []);
  return (
    <>
      <Helmet>
        <meta property="og:image" content={og_image} />
        <meta name="description" content="AI coding assistant for JetBrains IDEs including IntelliJ, Android Studio, and PyCharm" />
        <meta name="keywords" content="AI, coding assistant, JetBrains, IntelliJ, Android Studio, PyCharm, IDE, development tools" />
        <link rel="icon" type="image/png" sizes="16x16" href="/final-sweep-wizard_16x16.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/final-sweep-wizard_32x32.png" />
        <link rel="icon" type="image/png" sizes="48x48" href="/final-sweep-wizard_48x48.png" />
        <link rel="icon" type="image/png" sizes="64x64" href="/final-sweep-wizard_64x64.png" />
        <link rel="icon" type="image/png" sizes="128x128" href="/final-sweep-wizard_128x128.png" />
        <link rel="icon" type="image/png" sizes="256x256" href="/final-sweep-wizard_256x256.png" />
      </Helmet>
      <ChakraProvider theme={theme}>
        <ForceDarkMode>
          <Box
            textAlign="center"
            fontSize="xl"
            bgColor="#0d0a1a"
            bgImage={circles}
            bgPos="0 0"
            bgSize="100%"
            minH="100vh"
            bgRepeat="no-repeat"
            overflowX="hidden"
            width="100%"
            display="flex"
            flexDirection="column"
            paddingTop="80px"
          >
            {false && <ColorModeSwitcher />}
            {/* <Banner /> */}
            <Router>
              <Navbar />
              <Box flex="1">
                <Switch>
                  <Route exact path="/">
                    <CallToAction />
                    <Users />
                    <Features />
                    <Box
                      bgImage={`url(${pills_bottom})`}
                      bgPos="0 0"
                      bgSize="100%"
                      bgRepeat="no-repeat"
                      bgColor="#0d0a1a"
                    >
                      <TestimonialsPage />
                    </Box>
                  </Route>
                  <Route path="/about-us">
                    <AboutUs />
                  </Route>
                  <Route path="/pricing">
                    <PricingPage />
                  </Route>
                  <Route path="/signup">
                    <RedirectToExternal url={"https://form.typeform.com/to/aRlsi04N"} />
                  </Route>
                  <Route path="/install.sh">
                    <RedirectToExternal url="https://raw.githubusercontent.com/sweepai/sweep/main/bin/install_assistant.sh" />
                  </Route>
                  <Route path="/enterprise">
                    <SecurityPage />
                  </Route>
                  {/*<Route exact path="/blog">*/}
                  {/*  <BlogIndex />*/}
                  {/*</Route>*/}
                  {/*<Route path="/blog/:slug">*/}
                  {/*  <BlogPage />*/}
                  {/*</Route>*/}
                {/*<Route path="/compare">*/}
                {/*  <ComparisonPage />*/}
                {/*</Route>*/}
              </Switch>
              </Box>
              <Footer />
            </Router>
          </Box>
        </ForceDarkMode >
      </ChakraProvider >
    </>
  );
};
